module.exports = __webpack_public_path__ + "img/nav-logo.9a733eb3.svg";